import { Box, Paper, useTheme } from "@mui/material";
import Headers from "../../components/Headers";

import { tokens } from "../../theme";
import { TextField, Button } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import SendOutlinedIcon from "@mui/icons-material/SendOutlined";
// import Snackbar from "../../components/Snackbar/Snackbar";
import { useState } from "react";
// import { useMessageStore } from "../../Utils/Store";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as yup from "yup";
import { useLoginStore } from "../../Utils/Store";

const SingleSend = ({ onMessageSent }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [status, setStatus] = useState(false);
  // const [message, setMessage] = useState([]);
  const navigate = useNavigate();

  const isLogin = useLoginStore((state) => state.isLogin);

  // useEffect(() => {
  //   if (isLogin) {
  //     const { username, password, access_level, firstname } = isLogin;
  //   }
  // }, [isLogin]);

  const phoneRegExp = /^09\d{9}$/;

  const initialValues = {
    numberInput: "",
    textInput: "",
  };

  const checkoutSchema = yup.object().shape({
    numberInput: yup
      .string()
      .matches(phoneRegExp, "Invalid Phone Number.")
      .required("required"),
    textInput: yup.string().required("required"),
  });

  const saveToDb = async (values) => {
    try {
      const config = {
        method: "post",
        url: process.env.REACT_APP_SMS_TO_DB,
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify({
          phone_number: values.numberInput,
          message: values.textInput,
          user_id: isLogin.id,
        }),
      };

      const response = await axios(config);

      setStatus(true);
      onMessageSent();
      navigate("/sent");
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Box m="20px">
      <Paper
        elevation={0}
        sx={{ borderRadius: "10px", background: colors.primary[400] }}
      >
        <Headers title="New Message" />
      </Paper>
      <Paper
        elevation={0}
        sx={{
          borderRadius: "10px",
          padding: "10px",
          background: colors.primary[400],
        }}
      >
        <Formik
          onSubmit={async (values, { setSubmitting, resetForm }) => {
            const response = await axios.post(process.env.REACT_APP_SEND_SMS, {
              phone_number: values.numberInput,
              message_content: values.textInput,
            });
            setStatus(true);
            saveToDb(values);
            resetForm();
          }}
          initialValues={initialValues}
          validationSchema={checkoutSchema}
        >
          {({
            values,
            errors,
            touched,
            handleBlur,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                display="grid"
                gap="30px"
                gridTemplateColumns="repeat(3, 1fr)"
                sx={{
                  "& > div": {
                    gridColumn: isNonMobile ? undefined : "span 3",
                  },
                }}
              >
                <TextField
                  fullWidth
                  type="text"
                  label="Phone Number"
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.numberInput}
                  name="numberInput"
                  error={!!touched.numberInput && !!errors.numberInput}
                  helperText={touched.numberInput && errors.numberInput}
                  sx={{ gridColumn: "span 1" }}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                    minLength: 11,
                    maxLength: 11,
                    onInput: (e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9]/g, "")
                        .substring(0, 11);
                      if (e.target.value.length >= 2) {
                        e.target.value = "09" + e.target.value.substring(2);
                      }
                    },
                  }}
                />
                <Box
                  gridColumn="span 3"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <TextField
                    fullWidth
                    multiline
                    rows={13}
                    type="text"
                    label="Message"
                    onBlur={handleBlur}
                    onChange={handleChange}
                    value={values.textInput}
                    name="textInput"
                    error={!!touched.textInput && !!errors.textInput}
                    helperText={touched.textInput && errors.textInput}
                    sx={{ gridColumn: "span 2" }}
                  />
                </Box>
              </Box>
              <Box display="flex" justifyContent="end" mt="20px">
                <Button
                  sx={{ cursor: "pointer" }}
                  type="submit"
                  color="secondary"
                  variant="contained"
                  disabled={isSubmitting}
                  startIcon={<SendOutlinedIcon style={{ fill: "#fff" }} />}
                >
                  Send
                </Button>
              </Box>
            </form>
          )}
        </Formik>
      </Paper>
      {/* {status && (
        <Snackbar
          snackbarRef={snackbarRef}
          messages={
            snackbarRef === "success" ? "message sent" : "message failed"
          }
          status={status}
          setStatus={setStatus}
        />
      )} */}
    </Box>
  );
};

export default SingleSend;
